import { useMutation } from "@tanstack/react-query";
import { useAuthenticatedRequestCreator } from "hooks/useRequests";

export enum BalanceTransferType {
    Unknown = 0,
    ConsignmentToSilent = 1,
    SilentToConsignment = 2
}

const useFundsTransfer = (type: BalanceTransferType) => {
    const request = useAuthenticatedRequestCreator<void, { amountInCents: number, breakerId: string }>(
        (data) => ({
            method: "post",
            url: "/customer/breakers/transfer",
            data: {
                ...data,
                type
            }
        }), [400]
    );

    const { mutateAsync: transferFunds, isLoading: isWorking } = useMutation(request);

    return { transferFunds, isWorking };
}

export default useFundsTransfer;